'use client';

import { formatDistanceToNowStrict } from 'date-fns';
import { useLifeStats } from '../../hooks/useLifeStats';
import { formatHm } from '../../lib/time';
import styles from './StatCards.module.css';

export const StatCards = () => {
  const { sleepPerNightMinutes, lastSync, syncPerDay } = useLifeStats();

  const cards: { label: string; value: string }[] = [
    {
      label: 'Last sync',
      value: lastSync
        ? formatDistanceToNowStrict(lastSync, { addSuffix: true })
        : '–',
    },
    {
      label: 'Sync events / day',
      value: syncPerDay != null ? Math.round(syncPerDay).toLocaleString() : '–',
    },
    {
      label: 'Sleep / night',
      value:
        sleepPerNightMinutes != null ? formatHm(sleepPerNightMinutes) : '–',
    },
  ];

  return (
    <div className={styles.grid}>
      {cards.map((card) => (
        <div key={card.label} className={styles.card}>
          <div className={styles.value}>{card.value}</div>
          <div className={styles.label}>{card.label}</div>
        </div>
      ))}
    </div>
  );
};
